import React, { useState } from 'react';

import { AdsExpansionPanel } from '@arm/arm-design-system-react';
import { extractPrefixedProperties } from '../SharedUtils/utils';

const getThemeProperties = (obj, isLight) => {
  if (obj === null || obj === undefined) return {};
  return extractPrefixedProperties(obj, isLight ? 'Light' : 'Dark');
};

const ExpansionPanel = (props) => {
  const [isOpen, setIsOpen] = useState(props.fields.isExpand.value);

  const togglePanel = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  let widgetStyleList = {};
  const themeProperties = getThemeProperties(props.fields, props.isLight);

  if (themeProperties.PanelBackgroundColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-content-background-color'] =
      themeProperties.PanelBackgroundColor?.value;
  }
  if (themeProperties.PanelTextColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-content-color'] = themeProperties.PanelTextColor?.value;
  }
  if (themeProperties.PanelTextColor?.value !== '') {
    widgetStyleList['--ads-paragraph-color'] = themeProperties.PanelTextColor?.value;
  }
  if (themeProperties.ToggleBackgroundColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-toggle-background-color'] =
      themeProperties.ToggleBackgroundColor?.value;
  }
  if (themeProperties.ToggleHoverBackgroundColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-toggle-background-color-hover'] =
      themeProperties.ToggleHoverBackgroundColor?.value;
  }

  if (themeProperties.ToggleTextColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-toggle-color'] = themeProperties.ToggleTextColor?.value;
  }

  if (themeProperties.ToggleHoverTextColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-toggle-color-hover'] =
      themeProperties.ToggleHoverTextColor?.value;
  }

  if (themeProperties.ToggleIconColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-toggle-icon-color'] =
      themeProperties.ToggleIconColor?.value;
  }
  if (themeProperties.ToggleIconHoverColor?.value !== '') {
    widgetStyleList['--ads-expansion-panel-toggle-icon-color-hover'] =
      themeProperties.ToggleIconHoverColor?.value;
  }

  return (
    <AdsExpansionPanel
      style={widgetStyleList}
      expanded={isOpen}
      expansionChangeHandler={() => togglePanel(props.id)}
    >
      <span slot="toggle">
        <div dangerouslySetInnerHTML={{ __html: props.fields.Title.value }} />
      </span>
      <span slot="content">
        <div dangerouslySetInnerHTML={{ __html: props.fields.Description.value }} />
      </span>
    </AdsExpansionPanel>
  );
};

export default ExpansionPanel;
